import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const CoffeeIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/coffee"><path id="Icon" d="M4.5 10.5h11.25v4.125a4.125 4.125 0 0 1-4.125 4.125h-3A4.125 4.125 0 0 1 4.5 14.625V10.5Zm11.25 1.5h1.5a2.25 2.25 0 0 1 0 4.5h-1.5M3 21h14.25M8.25 3.75c-1.125 1.125-1.125 2.25 0 3.375M12 3.75c-1.125 1.125-1.125 2.25 0 3.375" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CoffeeIcon;